package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.refScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.veldekar.CircleButtonVariant
import com.veldekar.UncoloredButtonVariant
import org.jetbrains.compose.web.css.em
import org.w3c.dom.HTMLButtonElement

@Composable
fun IconButton(onClick: () -> Unit, ariaLabel: String? = null, content: @Composable () -> Unit) {
    Button(
        onClick = { onClick() },
        modifier = Modifier.setVariable(ButtonVars.FontSize, 1.em),
        variant = CircleButtonVariant.then(UncoloredButtonVariant),
        ref = if (ariaLabel != null) {
            refScope<HTMLButtonElement> {
                ref(ariaLabel) { element ->
                    element.setAttribute("aria-label", ariaLabel)
                }
            }
        } else {
            null
        }
    ) {
        content()
    }
}
